// eslint-disable-next-line no-unused-vars
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { ptToCanvas } from '@src/slide/infrastructure/module/independent/unit';

const elements = {};

/*
* TODO: define style properties exposed to user
*
* It may be useful to add something like `userProps` to each element that
* defines which props are actually exposed to the user through the ui.
*
* Could be an array:
*
* userProps: ['size', 'font']
*
* Could be objects that provide more useful metadata & input rendering components:
*
* userProps: {
*   size: {
*     type: 'number',
*     ComponentClass: NumberInput
*   },
*   color: {
*     type: 'color',
*     ComponentClass: ColorInput
*   }
* }
*/

elements[UIModelType.SHAPE] = {
    type: UIModelType.SHAPE,
    defaultWidth: ptToCanvas(52),
    defaultHeight: ptToCanvas(36),
    props: {
        style: {
        },
    },
};

elements[UIModelType.TABLE] = {
    type: UIModelType.TABLE,
    defaultWidth: ptToCanvas(800),
    defaultHeight: ptToCanvas(200),
};

elements[UIModelType.IMAGE] = {
    type: UIModelType.IMAGE,
    props: {
        style: {
            width: ptToCanvas(281),
            height: ptToCanvas(200),
        },
    },
};

export default elements;
